import { render } from "./CashTableCreator.vue?vue&type=template&id=d97a9788"
import script from "./CashTableCreator.vue?vue&type=script&lang=js"
export * from "./CashTableCreator.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__